import { useState } from "react";
import useAxios from "axios-hooks";
import { axiosInstance } from '../../../../../api/config';
import DeleteConfirmationDialog from "../../../../Util/DeleteConfirmationDialog";
import env from "../../../../../env";

const DeleteNotification = ({
  showModal,
  toggleShowModal,
  onDelete,
  notificationId,
  notificationTitle,
}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const { REACT_APP_API_BASE_URI } = env;

  const [{ loading }, executeDelete] = useAxios(
    {
      url: `2019-04-16/notifications/delete/${notificationId}`,
      method: "DELETE",
      baseURL: REACT_APP_API_BASE_URI,
    },
    { axios: axiosInstance, manual: true }
  );

  const onConfirmDelete = async () => {
    try {
      const response = await executeDelete({ data: {} });
      if (response?.status >= 200 && response?.status < 300) {
        setErrorMessage("");
        onDelete?.();
        toggleShowModal();
        return true;
      }
    } catch (error) {
      const apiMessage =
        error?.response?.data?.message || error?.response?.data || error?.message;
      setErrorMessage(
        apiMessage ||
          "Unable to delete this site notification. Please ensure it is not in use and try again."
      );
    }

    return false;
  };

  return (
    <DeleteConfirmationDialog
      isVisible={showModal}
      onDismiss={() => {
        setErrorMessage("");
        toggleShowModal();
      }}
      onConfirm={onConfirmDelete}
      resourceName={notificationTitle}
      resourceType="site notification"
      confirmationValue={notificationTitle || "delete"}
      isDeleting={loading}
      errorMessage={errorMessage}
    />
  );
};

export default DeleteNotification;